import { HubspotClient } from '../models/hubspot'

// Initialize HubSpot client for feedback forms
const HSclient = new HubspotClient({
  portalId: '22080564',
  formId: 'ff620b79-2e7d-4c08-93ff-3f1a40ee6b1b',
})

/**
 * Send plan downgrade feedback to HubSpot
 * @param {Object} values - Feedback form values
 * @param {string} values.reason - Reason for downgrade
 * @param {string} values.otherReason - Additional details if "Other" is selected
 * @param {string} values.feedback - User feedback text
 * @returns {Promise<{error: null|Error}>}
 */
export const sendToHubspot = async (values) => {
  try {
    const { reason, otherReason, feedback } = values
    const payload = {
      'TICKET.hs_ticket_category': 'PLAN_DOWNGRADE',
      email: window.shopify.data.user?.email || '',
      'TICKET.subject': otherReason || reason,
      'TICKET.content': feedback,
      shopify_domain: window.shopify.data.shop?.myshopifyDomain || '',
    }
    await HSclient.sendForm(payload)
    return {
      error: null,
    }
  } catch (e) {
    return {
      error: e.message || e,
    }
  }
}